import { createFileRoute } from '@tanstack/react-router'

import { AttestationsPageSkeleton } from '#/modules/contract/front-office/attestations-page/attestations-page-skeleton.tsx'
import { AttestationsPage } from '#/modules/contract/front-office/attestations-page/attestations-page.tsx'
import { CONTRACT_DOCUMENTS_QUERY_OPTIONS } from '#/modules/contract/queries/contract-documents-query-options.ts'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/(customer)/_shell/contracts/$subscriptionId/attestations/')({
  beforeLoad: (options) => requirePermissions(options, ['contract.read']),
  loader: ({ context, params }) =>
    context.queryClient.prefetchQuery(
      context.trpc.subscriptionDocuments.listContractDocuments.queryOptions(
        { subscriptionId: params.subscriptionId },
        CONTRACT_DOCUMENTS_QUERY_OPTIONS,
      ),
    ),
  pendingComponent: AttestationsPageSkeleton,
  pendingMs: 150,
  component: AttestationsRoute,
})

function AttestationsRoute() {
  const { subscriptionId } = Route.useParams()
  return <AttestationsPage subscriptionId={subscriptionId} />
}
